<template>
  <MainLayout hide-route-header>
    <Card class="max-w-lg mx-auto">
      <CardHeader>
        <CardTitle id="users-title">Setup your Humaniz phone number</CardTitle>
        <CardDescription>
          Text messages you send to candidates and teammates will come from this number.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form @submit.prevent="setupPhoneNumber">
          <div class="mt-4">
            <TextInput v-model="areaCode" label="Preferred area code" placeholder="415" type="tel" :maxlength="3" />
          </div>
          <div class="mt-4">
            <TButton :disabled="!validAreaCode" label="Setup phone number" />
          </div>
        </form>
      </CardContent>
    </Card>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import TextInput from '../../components/shared/TextInput.vue';
import { createPhoneNumber } from '../../api/quickstart.ts';
import { toast } from 'vue-sonner';

export default {
  name: 'QuickstartPhoneNumber',
  components: {
    MainLayout,
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
    TextInput,
  },
  data() {
    return {
      areaCode: '',
    };
  },
  computed: {
    validAreaCode() {
      return this.areaCode.match(/^\d{3}$/);
    },
  },
  methods: {
    async setupPhoneNumber() {
      const data = await createPhoneNumber(this.areaCode);

      if (data.status != 'error') {
        await this.$router.push('/');
        toast.success('Phone number created!', {
          action: { label: 'Dismiss' },
          description: `Your new Humaniz phone number ${data.record.phone_number} is ready to use.`,
        });
      } else {
        toast.error('Error creating phone number', {
          action: { label: 'Dismiss' },
          description: data.message,
        });
      }
    },
  },
};
</script>
